var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 457,
    viewBox: "0 0 360 457",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M278.058 2.44377C266.685 0.836778 255.113 0 243.426 0C178.405 0 117.273 25.322 71.2973 71.2973C25.322 117.273 0 178.405 0 243.426C0 308.448 25.322 369.58 71.2973 415.555C87.4148 431.673 105.396 445.232 124.746 456.073C108.458 432.681 98.9015 404.287 98.9015 373.688C98.9015 293.994 163.733 229.163 243.426 229.163C307.392 229.163 359.425 177.121 359.425 113.165C359.425 61.256 325.155 17.211 278.058 2.44377ZM243.426 165.882C220.985 165.882 202.719 147.625 202.719 125.174C202.719 102.724 220.985 84.467 243.426 84.467C265.867 84.467 284.134 102.724 284.134 125.174C284.134 147.625 265.877 165.882 243.426 165.882Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 244,
    cy: 126,
    r: 41,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackSvg);
export default __webpack_public_path__ + "static/media/BlackSvg.658401ecf7e9f51d0d62df0bc41c4fc2.svg";
export { ForwardRef as ReactComponent };